'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteWeekSelector', ['TimeService', function(TimeService) {
    return {
      restrict: 'A',
      scope: {
        baseDate: '@',
        label: '@',
        showDays: '@'
      },
      template: '<div class="clearfix"><div class="days-of-week" ng-if="state.showDays"><div class="day-label" ng-repeat="day in weekTwixes">{{ day.twix.start.format(\'ddd\') }}</div></div></div><div class="clearfix"><div class="label">{{ state.label }}</div><div class="week-box"><span sa-note-modify-context action="date|{{day.twix.start.format()}}" class="date-box {{day.flag}}" ng-repeat="day in weekTwixes"><span class="modify-context-click">{{ day.twix.start.format(\'MMM DD\') }}</span></span></div></div>',
      link: function(scope, element, attr) {
        scope.state = {
          showDays: attr['showDays'],
          baseDate: scope.baseDate,
          label: scope.label,
          todayTwx: TimeService.getDayTwixFromDate(TimeService.getNowInStoreTime())
        };

        scope.state.tomorrowTwx = TimeService.getDayTwixFromDate(TimeService.getNowInStoreTime().add(1, 'days'));
        scope.state.yesterdayTwx = TimeService.getDayTwixFromDate(TimeService.getNowInStoreTime().subtract(1, 'days'));
        
        function getWeek() {
          return TimeService.getWeekTwixFromMoment(moment(scope.state.baseDate));
        }

        function generateDayFlag(mmt) {
          if (scope.state.todayTwx.start.isSame(mmt)) {
            return 'today';
          } else if (scope.state.tomorrowTwx.start.isSame(mmt)) {
            return 'tomorrow';
          } else if (scope.state.yesterdayTwx.start.isSame(mmt)) {
            return 'yesterday'
          } else {
            return '';
          }
        }

        function generateWeekTwixes() {
          var week = getWeek();

          return _.map(_.range(7), function(dayNum) {
            var mmt = moment(week.start).add(dayNum, 'days');
            return {
              flag: generateDayFlag(mmt),
              twix: mmt.twix(moment(week.start).add(dayNum + 1, 'days'))
            }
          });
        }

        scope.weekTwixes = generateWeekTwixes();
      }
    }
  }]);
